import React from 'react';
import { Helmet } from 'react-helmet-async';

export const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Plumber",
    "name": "NHM Plomberie",
    "image": "https://nhm-plomberie.fr/logo.png",
    "@id": "https://nhm-plomberie.fr",
    "url": "https://nhm-plomberie.fr",
    "telephone": "+33970705863",
    "priceRange": "€€",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "18 rue Legendre",
      "addressLocality": "Paris",
      "postalCode": "75017",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 48.8850,
      "longitude": 2.3200
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "08:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "17:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Sunday",
        "opens": "00:00",
        "closes": "23:59",
        "description": "Urgences uniquement"
      }
    ],
    "areaServed": [
      {
        "@type": "City",
        "name": "Paris 17e"
      },
      {
        "@type": "City",
        "name": "Paris 8e"
      },
      {
        "@type": "City",
        "name": "Paris 9e"
      },
      {
        "@type": "City",
        "name": "Paris 16e"
      },
      {
        "@type": "City",
        "name": "Paris 18e"
      },
      {
        "@type": "City",
        "name": "Levallois-Perret"
      },
      {
        "@type": "City",
        "name": "Clichy"
      },
      {
        "@type": "City",
        "name": "Neuilly-sur-Seine"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de plomberie",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Dépannage urgence 24/7",
            "description": "Intervention rapide pour urgences plomberie"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Débouchage canalisation",
            "description": "Débouchage professionnel de canalisations"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Réparation fuite d'eau",
            "description": "Détection et réparation de fuites"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Installation sanitaire",
            "description": "Installation complète salle de bain et cuisine"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Chauffe-eau",
            "description": "Installation et réparation chauffe-eau"
          }
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const BreadcrumbSchema = ({ items }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};